<template>
  <v-app
    :class="showSeeBackground ? 'app-container-background' : ''"
  >
    <template v-if="preloading">
    </template>
    <router-view v-else />
  </v-app>
</template>

<script>
import oldUrls from './oldUrls.json'
import sharedMethods from './methods/sharedMethods'
import api from './api.js'
import { createHelpers } from 'vuex-map-fields'
import state from './state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'App',

  data () {
    return {
      preloading: true
    }
  },

  created () {
    this.loadLocalFavorites()
    this.tryOldUrlRedirect()

    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('showArticleOnly') && parseInt(urlParams.get('showArticleOnly')) === 1) {
      this.showArticleOnly = true
    }

    this.openTs = +new Date()
    this.lang = this.getLangFromUrl(this.$route.path) || 'en'
    if (!this.languages.includes(this.lang)) {
      this.lang = 'en'
    }
    this.$i18n.locale = this.lang
    this.isHomepage = this.homepage

    if (this.$route.name === 'calendar') {
      this.preloading = false
      return
    } else {
      // Is site app, so set background image
      // console.log('apply background prop correct')
      // document.documentElement.style.setProperty('--background-prop', getComputedStyle(document.documentElement).getPropertyValue('--background-prop-img'))
    }

    this.$store.dispatch('getHotObjects')
    this.getBookingFormInfoFromUrl()
    // First priority stuff

    api.getSiteMenu().then(response => {
      if (response.items) {
        this.$store.dispatch('setVal', {
          k: 'menuResponse',
          v: response.items
        })
        this.setPagesById(response.items)
        // First priority stuff
        api.getTemplateVars().then(response => {
          this.setTemplateVarsByLang(response.items)
          this.preloading = false
        })
        // Second priority stuff
        api.getSiteBanners().then(response => {
          this.setBannersByLang(response.items)
          api.getGalleries().then(response => {
            this.setGalleriesByArticleId(response.items)
          })
        })
        this.$store.dispatch('getFeatures')
        api.getBookingExtras().then(response => {
          this.bookingExtras = response.items
        })
        api.getObjectRegions().then(response => {
          this.objectRegions = response.items
        })
        api.getWeather().then(response => {
          if (response && response.items && response.items[0] && response.items[0].jsonData) {
            try {
              this.weather = JSON.parse(response.items[0].jsonData)
            } catch (err) {
              // eslint-disable-next-line no-console
              console.log('weather json broken', err)
            }
          }
        })
      }
    })
    window.addEventListener('resize', this.resizeHandler)
    window.addEventListener('scroll', this.scrollHandler)
    this.updateWindowWidth()
  },

  destroyed () {
    window.removeEventListener('resize', this.resizeHandler)
    window.removeEventListener('scroll', this.scrollHandler)
  },

  watch: {
    homepage (value) {
      this.isHomepage = this.homepage
    },

    routeFullPath (value) {
      let langBefore = this.lang
      let newLang =this.getLangFromUrl(this.$route.path)
      if (newLang && newLang !== langBefore && langBefore) {
        this.lang = newLang
        this.$i18n.locale = newLang
      }
      this.getBookingFormInfoFromUrl()
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    showSeeBackground () {
      return this.$route.name !== 'calendar'
    },

    routeFullPath () {
      return this.$route.fullPath
    },

    homepage () {
      return this.$route.name === 'homewlang' || this.$route.name === 'home'
    },

    menuResponse () {
      return this.$store.getters['menuResponse']
    },
  },

  mounted() {
    // Fix breakpoints not working in Facebook Mobile browser
    setTimeout(() => {
      this.$vuetify.clientHeight--
      this.$nextTick(() => {
        this.$vuetify.clientHeight++
      })
    }, 1000)
  },

  methods: {
    ...sharedMethods,

    scrollHandler (e) {
      this.scrolledTop = window.scrollY
    },

    updateWindowWidth () {
      if (window.innerWidth !== this.windowWidth) {
        this.windowWidth = window.innerWidth
      }
      setTimeout(() => {
        this.updateWindowWidth()
      }, 250)
    },

    resizeHandler () {
      this.windowHeight = window.innerHeight
      this.windowWidth = window.innerWidth
    },

    tryOldUrlRedirect () {
      const pathName = window.location.pathname
      if (!pathName) { return }
      const pathParts = pathName.split('/')
      if (!pathParts || pathParts.length < 2) { return }
      let key = pathParts[1] + '/' + pathParts[2]
      const newLangs = {
        eng: 'en',
        fin: 'fi',
        est: 'et',
        rus: 'ru',
        esp: 'es'
      }
      const objectLinkWithoutLang = oldUrls['eng/' + pathParts[1]]
      if (oldUrls[key] || objectLinkWithoutLang) {
        if (objectLinkWithoutLang) {
          key = 'eng/' + pathParts[1]
        }
        api.getOneItemWithQuery('objects', oldUrls[key], [])
          .then(object => {
            this.$router.push({ path: this.objectLinkWithLang(object, objectLinkWithoutLang ? 'en' : newLangs[pathParts[1]]) })
          })
      }
    },

    loadLocalFavorites () {
      const localFavorites = window.localStorage.getItem('my_favorites')
      try {
        if (localFavorites && JSON.parse(localFavorites)) {
          this.favorites = JSON.parse(localFavorites)
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('local-storage-my-favorites', err)
      }
    },

    setBannersByLang (banners) {
      let bannersByLang = {}
      banners.forEach(banner => {
        let lang = banner.languageRef && banner.languageRef.languageCode || 'undefined'
        if (!bannersByLang[lang]) [
          bannersByLang[lang] = []
        ]
        bannersByLang[lang].push(banner)
      })
      this.$store.dispatch('setVal', {
        k: 'bannersByLang',
        v: bannersByLang
      })
    },

    setGalleriesByArticleId (galleries) {
      let byArticle = {}
      galleries.forEach(gallery => {
        let articleId = gallery.showForArticle ? gallery.showForArticle._id : 'none'
        if (!byArticle[articleId]) {
          byArticle[articleId] = []
        }
        byArticle[articleId].push(gallery)
      })
      this.$store.dispatch('setVal', {
        k: 'galleriesByArticleId',
        v: byArticle
      })
    },

    setPagesById (pages) {
      let pagesById = {}
      let pagesBySeoName = {}
      pages.forEach(page => {
        pagesById[page._id] = page
        this.languages.forEach(lang => {
          if (page['seoName_' + lang]) {
            pagesBySeoName[page['seoName_' + lang]] = page
          }
        })
      })
      this.$store.dispatch('setVal', {
        k: 'pagesById',
        v: pagesById
      })
      this.$store.dispatch('setVal', {
        k: 'pagesBySeoName',
        v: pagesBySeoName
      })
    },

    setTemplateVarsByLang (vars) {
      let templateVarsByLang = {};
      ['et', 'en', 'fi', 'es', 'ru'].forEach(lang => {
        templateVarsByLang[lang] = {};
        vars.forEach(prop => {
          templateVarsByLang[lang][prop.propertyName] = prop['translation_' + lang]
        })
      })
      this.$store.dispatch('setVal', {
        k: 'templateVarsByLang',
        v: templateVarsByLang
      })
    }
  }
}
</script>

<style>
  @import './style.css';
  html {
    /* scroll-behavior: smooth; */
  }

body:before {
  content: "";
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -10;
}
</style>

<style lang="stylus">
select
  background-color white !important
  border-color #848484 #c1c1c1 #e1e1e1 !important
  border-style solid !important
.main-container
  max-width 1187px !important
.zero-padding
  padding 0 !important
.v-text-field.v-text-field--solo .v-input__control
  min-height inherit !important
body
  line-height 1.5
  color: gray !important

.application--wrap
  overflow-x: hidden;
  overflow-y: auto;
.header
  position: relative;
.slogan
  font-style italic
  text-align center
  color white
  font 20px 'Cambria-Italic'
  text-shadow 1px 1px 1px #999, 0 0 2px #ccc, 0 0 2px #999
.menu-outer
  background url(../public/img/menu_bg.jpg) repeat 0 top
  height 48px
  text-align center
  margin auto
.menu-inner
  display table
  margin 0 auto
.menu-level-1
  position relative
  float left
  margin 0
  color black
  line-height 32px
  font-size 13px
  padding 10px 15px 6px 15px
  cursor pointer
.menu-level-1:hover
  color white
  background #219bc8
.menu-level-2
  min-width 200px
  padding 0 15px
.menu-level-2:hover
  background #ffcb01
  color #333
.test1
  color red
.submenu
  z-index 1050
  position absolute
  min-width 200px
  top 48px
  margin 0
  padding 0
  left 0
  background #219bc8
  text-align left
.content-area
  padding 20px
  min-height 600px
  background white
.search-div
  background #ffcb01
  padding 15px
.search-form-title
  padding-top 5px
.search-form-title-red
  padding-top 5px
  color red
  font-weight 700
.search-div-mobile .input_full
  border-radius 8px
.input_full
  width 100%
.search-button
  background #e0bc31 important
textarea, select, input[type="date"], input[type="datetime"], input[type="datetime-local"], input[type="email"], input[type="month"], input[type="number"], input[type="password"], input[type="search"], input[type="tel"], input[type="text"], input[type="time"], input[type="url"], input[type="week"]
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-background-clip: padding;
  -moz-background-clip: padding;
  background-clip: padding-box;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  -ms-border-radius: 0;
  -o-border-radius: 0;
  border-radius: 0;
  -webkit-appearance: none;
  background-color: white;
  border: 1px solid;
  border-color: #848484 #c1c1c1 #e1e1e1;
  color: black;
  outline: 0;
  margin: 0;
  padding: 2px 3px;
  text-align: left;
  font-size: 13px;
  font-family: Arial, "Liberation Sans", FreeSans, sans-serif;
  height: 1.8em;
  vertical-align: top;
input[type="text"].filter-calendar, input[type="text"].contact_calendar_icon
  background: url(../public/img/calendar-icon.png) no-repeat left top;
  background-position: 2px 1px;
  padding-left: 25px;
  margin: 0;
  background-color: white;

.v-pagination__navigation
  padding inherit !important


</style>

<style>
.v-toolbar--fixed {
  z-index: 10 !important;
}
h1, h2, h3, h4, h5, h6 {
	color: #6b6b6b;
}
h1 {
  font-size: 2em;
  line-height: 1;
  margin-top: 1em;
  margin-bottom: 0.5em;
  font-weight: bold;
  color: #219bc8;
  /*color: #FFCB01;*/
}
h2 {
  font-weight: bold;
  font-size: 1.1em;
}
.list-object {
  background: white;
  width: 100%;
  color: #333;
  display: block;
  /* margin-left: 22px; */
  margin-bottom: 22px;
  padding: 0;
  overflow: hidden;
  position: relative;
  border-radius: 6px;
}
@media only screen and (max-width: 959px) {
  /*.list-object {
    margin-left: 10px;
    margin-left: 10px;
  }*/
}
.shadow {
  /* box-shadow: 3px 3px 5px #888; */
  box-shadow: 1px 1px 5px #aaa;
}
button, a.button, input[type="reset"], input[type="submit"], input[type="button"] {
  -webkit-appearance: none;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
  border-radius: 4px;
  -webkit-background-clip: padding;
  -moz-background-clip: padding;
  background-clip: padding-box;
  background: #fac400 url(../public/img/button.png) repeat-x;
  background-image: -webkit-gradient(linear, 50% 0%, 50% 100%, color-stop(0%, #ffc800), color-stop(100%, #fac400));
  background-image: -webkit-linear-gradient(#ffc800, #fac400);
  background-image: -moz-linear-gradient(#ffc800, #fac400);
  background-image: -o-linear-gradient(#ffc800, #fac400);
  background-image: linear-gradient(#ffc800, #fac400);
  border: 1px solid;
  border-color: #fac400 #bbbbbb #999999;
  cursor: pointer;
  color: #333333;
  display: inline-block;
  font: bold 12px/1.3 "Helvetica Neue", Arial, "Liberation Sans", FreeSans, sans-serif;
  outline: 0;
  overflow: visible;
  margin: 0;
  padding: 3px 10px;
  text-shadow: white 0 1px 1px;
  text-decoration: none;
  vertical-align: top;
  /* width: auto; */
}
.button-silver {
  background: #dddddd url('../public/img/button_silver.png') repeat-x !important;
  border-color: grey  #bbb #999 !important;
}
ul, menu, dir {
    display: block;
    list-style-type: disc;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    -webkit-padding-start: 40px;
}
.flags {
  position: absolute;
  right: 0;
  bottom: 0;
}
.flags a {
  padding-left: 5px;
}
.flags-menu {
  width: 100%;
}
.flags-menu a {
  padding-right: 5px;
}
select {
  background-image: url('data:image/png;base64,R0lGODlhDQAEAIAAAAAAAP8A/yH5BAEHAAEALAAAAAANAAQAAAILhA+hG5jMDpxvhgIAOw==');
  background-repeat: no-repeat;
  background-position: right center;
  padding-right: 20px;
}
button:hover, a.button:hover, input[type="reset"]:hover, input[type="submit"]:hover, input[type="button"]:hover {
  background-image: -webkit-gradient(linear, 50% 0%, 50% 100%, color-stop(0%, #ffffff), color-stop(1px, #ffc800), color-stop(100%, #f3bf01));
  background-image: -webkit-linear-gradient(#ffffff, #ffc800 1px, #f3bf01);
  background-image: -moz-linear-gradient(#ffffff, #ffc800 1px, #f3bf01);
  background-image: -o-linear-gradient(#ffffff, #ffc800 1px, #f3bf01);
  background-image: linear-gradient(#ffffff, #ffc800 1px, #f3bf01);
  text-decoration: none;
}


.calendar {
	margin: 0;
	padding: 0;
	width: 100%;
	border: 1px solid silver;
	color: black;
	border-collapse: collapse;
}

.calendar th {
	text-align: center;
	font-weight: bold;
	border: 1px solid silver;
	height: 20px;
}

.calendar caption {
	margin: 0;
	padding: .3em 0;
	background: #ffa51e;
}

.calendar td {
	padding: .1em .3em;
	width: 1em;
	text-align: center;
	border: 1px solid silver;
}

.calendar tr {
	height: 30px;
}

.calendar a {
	color: #000;
	text-decoration: none;
}

.calendar td.today {
	background: #ffc;
}

.calendar td.selected {
	border: 1px dotted #ff7800;
}

.calendar td.booked, .legend-booked {
	background: red;
}

.calendar td.am_booked {
	background: red; /*Old browsers */
	background: -moz-linear-gradient(-45deg, red 50%, white 50%); /*FF3.6+ */
	background: -webkit-gradient(linear, left top, right bottom, color-stop(50%,red), color-stop(50%,white)); /* Chrome,Safari4+ */
	background: -webkit-linear-gradient(-45deg, red 50%,white 50%); /* Chrome10+,Safari5.1+ */
	background: -o-linear-gradient(-45deg, red 50%,white 50%); /* Opera 11.10+ */
	background: -ms-linear-gradient(-45deg, red 50%,white 50%); /* IE10+ */
	background: linear-gradient(135deg, red 50%,white 50%);	/* W3C */
}

.calendar td.pm_booked {
	background: -moz-linear-gradient(-45deg, white 50%, red 50%); /*FF3.6+ */
	background: -webkit-gradient(linear, left top, right bottom, color-stop(50%,white), color-stop(50%,red)); /* Chrome,Safari4+ */
	background: -webkit-linear-gradient(-45deg, white 50%,red 50%); /* Chrome10+,Safari5.1+ */
	background: -o-linear-gradient(-45deg, white 50%,red 50%); /* Opera 11.10+ */
	background: -ms-linear-gradient(-45deg, white 50%,red 50%); /* IE10+ */
	background: linear-gradient(135deg, white 50%,red 50%);	/* W3C */
}

.calendar td.onhold, .legend-onhold {
	background: #ffcb01;
}

.calendar td.selected, .legend-selected {
	background: #219bc8;
}
.legend {
    display: inline-block;
    padding-top: 15px;
}
.legend-top {
  padding-top: 15px;
  display: inline-block;
}
.legend-item {
	display: inline-block;
	padding-bottom: 5px;
}

.legend-color {
	width: 25px;
	height: 20px;
	display: inline-block;
}

.calendar td.passed {
	color: silver;
}

.calendar td.selected-day {
	background: #219bc8 !important;
  color: white !important;
}

table.calendar td.pad {
	color: #999;
	background: #fff;
}

/*table.calendar td.pad:hover {
	background: none;
	border: 0;
}*/

/*.sunday, .saturday {
	background: #f0f0f0;
}*/

#year {
	padding: 0;
	width: 500px;
	list-style: none;
}

#year:after {
	content: "";
	display: block;
	height: 0;
	clear: both;
	visibility: hidden;
}

#year li {
	float: left;
	padding: 0 .5em .5em 0;
	height: 150px;
}

.calendar-nav {
	margin-bottom: 5px;
	text-align: center;
}

.calendar-nav-select-month {
  width: calc(100% - 134px);
}

.calendar-nav-select-year {
  width: 60px;
}

.calendar-nav-button {
	width: 30px;
}

.right-col {
  float:right;
  padding-left: 22px;
}

@media only screen and (max-width: 960px) {
  .right-col {
    padding-left: 0px;
  }
}

.left-col-wide {
  float:left;
  padding-right: 22px;
}
.left-col {
  position: relative;
  width: 237px;
  float: left;
}
.right-col-sidebar {
  width: 237px; float: right;
}
.hidden-div {
  display: none;
}

.list-object-text .object-properties li {
  list-style-type: none;
  content: "- ";
  display: table-row;
  font-size: 13.4px;
}
.front-object li:before, .list-object-descr li:before, .single-object-descr li:before, .share-object-descr li:before {
    content: "- ";
    padding-right: 7px;
    display: table-cell;
    text-align: left;
}
.list-object-text ul {
  margin: 0;
  padding: 0;
}
.list-object-descr h2 {
  font-weight: bold;
  font-size: 14px;
  max-height: 3em;
  overflow: hidden;
}
hr {
  width: 100%;
  display: block;
  unicode-bidi: isolate;
  margin-block-start: 0.5em;
  margin-block-end: 0.5em;
  margin-inline-start: auto;
  margin-inline-end: auto;
  overflow: hidden;
  border-style: inset;
  border-width: 1px;
}



.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: #ffc800;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #ffc800;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: #ffc800;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(#ffc800, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}
.mobile-button  {
  height: 40px;
  font-size: 18px !important;
}
.full-input {
  height: 25px !important;
  line-height: 21px !important;
}
.mobile-field {
  height: 36px !important;
  line-height: 30px !important;
  font-size: 16px !important;
}
.mobile-date {
  height: 36px !important;
  line-height: 30px !important;
  font-size: 16px !important;
  background-position:3px 7px !important;
}
.v-menu__content--fixed, .v-menu__content, .costa-border {
  border-radius: 4px !important;
}
.search-form-container {
  max-width: 500px;
}
.search-div {
  border-radius: 6px;
}
.filter-submit {
  height: 40px;
  font-size: 15px !important;
}

.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.v-navigation-drawer--temporary, .v-navigation-drawer--is-mobile {
  z-index: 10 !important;
}
</style>
